import axios from '../../../../config/axios'

/**
 * Protocol API manager.
 */
class ProtocolApiManager {

  /**
   * Constructor.
   *
   * @param {String} url
   */
  constructor (url) {
    this.url = url
  }

  /**
   * Paginate last sessions.
   *
   * @param {Number} userId
   * @param {Number} perPage
   * @param {Number} page
   * @returns {Promise<any>}
   */
  async paginateLastSessions ({userId, perPage = 5, page = 1}) {
    return await axios.get(
      `${this.url}/users/${userId}/last-sessions/${perPage}/${page}`,
      {},
    )
  }
}

export default ProtocolApiManager



// WEBPACK FOOTER //
// ./src/common/protocol/api/managers/ProtocolApiManager.js